import BlockComponentValue from './BlockComponentValue';

class BlockComponentVideo implements BlockComponentValue {
  settings: any;
  src: string;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockComponentVideo {
  export function make(
    settings: any,
    src: string,
  ): BlockComponentVideo {
    return {
      settings,
      src,
    };
  }

  export function getDefault(): BlockComponentVideo {
    return {
      settings: {
        autoplay: false,
        controls: false,
        loop: false,
        muted: false,
      },
      src: '/videos/video.mp4',
    };
  }
}

export default BlockComponentVideo;
